import { useField, useFormikContext } from "formik";
import ReCAPTCHA from "react-google-recaptcha";

const RecaptchaInput = ({ name }) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  return (
    <div style={{ marginBottom: "1rem" }}>
      <ReCAPTCHA
        style={{ display: "inline-block" }}
        sitekey="6LfWVA8iAAAAAFERHAfJEDVMhwJ8axydb2Lcuy7j"
        onChange={(value) => setFieldValue(name, value)}
      />
      <div style={{ display: "block" }}>
        {meta.error ? (
          <span style={{ color: "red", fontSize: "12px", width: "100%" }}>
            {meta.error}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default RecaptchaInput;
